import { gql } from '@apollo/client'

export const SIGN_IN = gql`
mutation Login(
  $email: String!
  $password: String!
){
  loginUser(
    email: $email
		password: $password
  ){
    success
    refresh
    access
    user{
      id
      name
      email
      isStaff
    }
  }
}`